export const legalLinks = [
  {
    label: "Privacy Policy",
    url: "/privacy-policy/",
    id: "cG9zdDozMTI1MDg=",
  },
  {
    label: "Terms of Use",
    url: "/terms-of-use/",
    id: "cG9zdDozMTI1MTE=",
  },
  {
    label: "Advertising Policy",
    url: "/advertising-policy/",
    id: "cG9zdDozMTI1MDk=",
  },
  {
    label: "Cookie Policy",
    url: "/cookie-policy/",
    id: "cG9zdDozMTI1MTA=",
  },
]
